import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "@common/axios";
import ListItemTestResult from "@common/ListItemTestResult";
import ShortcutLink from "@common/ShortcutLink";
import {BrandContext} from "@context/BrandContext";
import CircularLoader from "@common/CircularLoader";

const ProgressDashboardWidget = props => {
    const [progressResults, setProgressResults] = useState();
    const [isLoading, setLoading] = useState(true);
    const brandConfig = useContext(BrandContext);

    useEffect(() => {
        axios.get('/web/ui/report/student/progressReport')
            .then(response => {
                setProgressResults(response.data);
                setLoading(false);
            });
    }, []);

    const handleChange = selectedOption => {
        setClassId(selectedOption.value);
    }

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-title-with-icon">
                    <svg className="ch-icon-medium" viewBox="0 0 128 128">
                        <use href="#reports-icon"></use>
                    </svg>
                    <ShortcutLink className="ch-highlight" shortcutUrl={'/reports/loadStudentAchievementReportForStudent.action'}>
                        <span>Progress</span>
                    </ShortcutLink>
                </div>
            } isLoading={isLoading}>
            <div className="ch-dashboard-blk-body">
                <div className="ch-report-key">
                    <span className="ch-report-key-item"><span className="ch-report-key-item-title">{brandConfig.brandText.questionLevel1Abr}</span> - {brandConfig.questionLevelNames[0]}</span>
                    <span className="ch-report-key-item"><span className="ch-report-key-item-title">{brandConfig.brandText.questionLevel2Abr}</span> - {brandConfig.questionLevelNames[1]}</span>
                    <span className="ch-report-key-item"><span className="ch-report-key-item-title">{brandConfig.brandText.questionLevel3Abr}</span> - {brandConfig.questionLevelNames[2]}</span>
                    <span className="ch-report-key-item"><span className="ch-report-key-item-title">{brandConfig.brandText.questionLevel4Abr}</span> - {brandConfig.questionLevelNames[3]}</span>
                </div>
                {progressResults !== undefined && progressResults.reportData !== undefined && progressResults.reportData.length > 0 &&
                    <table className="gen-table" style={{width: '100%'}}>
                        <tbody>
                            {progressResults.reportData.map((progressResult, index) => {
                               return <React.Fragment key={index}>
                                    {(index == 0 || progressResults.reportData[index - 1].topicId !== progressResult.topicId) && (
                                        <tr key={progressResult.topicId}>
                                            <th>{progressResult.topicName}</th>
                                            <th style={{textAlign: 'center'}}>{brandConfig.brandText.questionLevel1Abr}</th>
                                            <th style={{textAlign: 'center'}}>{brandConfig.brandText.questionLevel2Abr}</th>
                                            <th style={{textAlign: 'center'}}>{brandConfig.brandText.questionLevel3Abr}</th>
                                            <th style={{textAlign: 'center'}}>{brandConfig.brandText.questionLevel4Abr}</th>
                                        </tr>
                                    )}
                                    <tr key={progressResult.conceptId}>
                                        <td>{progressResult.conceptName}</td>
                                        <td style={{textAlign: 'center'}}>
                                            {(progressResult.level1Achieved === undefined || progressResult.level1Achieved  === 0)  && progressResult.successes1 == 0 && progressResult.failures1 == 0 && (
                                                <div className="star"></div>
                                            )}

                                            {(progressResult.level1Achieved === undefined || progressResult.level1Achieved  === 0) && (progressResult.successes1 > 0 || progressResult.failures1 > 0) && (
                                                <div className="star attempted"></div>
                                            )}

                                            {progressResult.level1Achieved == 1 && (
                                                <div className="star achieved"></div>
                                            )}
                                        </td>
                                        <td style={{textAlign: 'center'}}>
                                            {(progressResult.level2Achieved === undefined || progressResult.level2Achieved  === 0)  && progressResult.successes2 == 0 && progressResult.failures2 == 0 && (
                                                <div className="star"></div>
                                            )}

                                            {(progressResult.level2Achieved === undefined || progressResult.level2Achieved  === 0) && (progressResult.successes2 > 0 || progressResult.failures2 > 0) && (
                                                <div className="star attempted"></div>
                                            )}
                                            {progressResult.level2Achieved == 1 && (
                                                <div className="star achieved"></div>
                                            )}
                                        </td>
                                        <td style={{textAlign: 'center'}}>
                                            {(progressResult.level3Achieved === undefined || progressResult.level3Achieved  === 0)  && progressResult.successes3 == 0 && progressResult.failures3 == 0 && (
                                                <div className="star"></div>
                                            )}

                                            {(progressResult.level3Achieved === undefined || progressResult.level3Achieved  === 0) && (progressResult.successes3 > 0 || progressResult.failures3 > 0) && (
                                                <div className="star attempted"></div>
                                            )}

                                            {progressResult.level3Achieved === 1 && (
                                                <div className="star achieved"></div>
                                            )}
                                        </td>
                                        <td style={{textAlign: 'center'}}>
                                            {(progressResult.level4Achieved === undefined || progressResult.level4Achieved  === 0)  && progressResult.successes4 == 0 && progressResult.failures4 == 0 && (
                                                <div className="star"></div>
                                            )}

                                            {(progressResult.level4Achieved === undefined || progressResult.level4Achieved  === 0) && (progressResult.successes4 > 0 || progressResult.failures4 > 0) && (
                                                <div className="star attempted"></div>
                                            )}

                                            {progressResult.level4Achieved == 1 && (
                                                <div className="star achieved"></div>
                                            )}
                                        </td>
                                    </tr>
                                </React.Fragment>
                            })}
                        </tbody>
                    </table>
                }
            </div>
        </DashboardWidget>
    )
}

export default ProgressDashboardWidget;